import { useSyncExternalStore } from "react";

/**
 * List or grid, remembered per device.
 *
 * An external store rather than component state: Home and BrowseType both show
 * the same list, and switching on one screen should not reset on the other.
 */
export type ViewMode = "list" | "grid";

const KEY = "art-directory:view";

function read(): ViewMode {
  try {
    return localStorage.getItem(KEY) === "grid" ? "grid" : "list";
  } catch {
    return "list";
  }
}

let current: ViewMode = read();
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function setViewMode(next: ViewMode): void {
  if (next === current) return;
  current = next;
  try {
    localStorage.setItem(KEY, next);
  } catch {
    // The choice just will not survive a reload.
  }
  for (const listener of listeners) listener();
}

export function useViewMode(): ViewMode {
  return useSyncExternalStore(
    subscribe,
    () => current,
    () => current,
  );
}
